<template>
    <div class="row px-3">
        <div
            class="algolia-listing-product-block__wrapper"
            v-for="(item, index) in formattedItems"
            :key="index"
            :class="{'col-12 col-md-12': !item.objectID, 'col-6 col-md-12': item.objectID}"
        >

            <HitItem
                v-if="item.objectID"
                :item="item"
                :lang-iso="langIso"
                :page-type="pageType"
                @algoliaEvent="sendClickEvent($event, item)"
            />

            <ActionBanner
                v-else
                :action-banner="item"
            />

        </div>
    </div>
</template>

<script>
import HitItem from "./HitItem";
import ActionBanner from "./ActionBanner";

export default {
    name: "HitItems",
    components: {
        HitItem,
        ActionBanner,
    },
    props: {
        items: {
            type: Array,
            required: true
        },
        pageType: {
            type: String,
            required: true
        },
        langIso: {
            type: String,
            required: false,
            default: "nl-NL"
        },
        actionBanners: {
            type: Array,
            required: false,
            default: () => [],
        }
    },
    computed: {
        formattedItems() {
            let newItems = this.items;
            newItems.forEach((item, index) => {
                let shouldPushIntoItem = this.isAllowedToDisplayActionBanner(index, this.actionBanners, 5);

                if (shouldPushIntoItem) {

                    let actionBanner = this.isAllowedToDisplayActionBanner(index, this.actionBanners, 5, 1);
                    if (actionBanner) {
                        newItems.splice(index, 0, actionBanner)
                    }

                }
            });

            return newItems;
        },
        formattedItemsMobile() {
            let newItems = this.items;
            newItems.forEach((item, index) => {
                let shouldPushIntoItem = this.isAllowedToDisplayActionBanner(index, this.actionBanners, 6);

                if (shouldPushIntoItem) {

                    let actionBanner = this.isAllowedToDisplayActionBanner(index, this.actionBanners, 6, 1);
                    if (actionBanner) {
                        newItems.splice(index, 0, actionBanner)
                    }

                }
            });

            return newItems;

        },
    },
    methods: {
        sendClickEvent(title, item) {
            this.$emit('algoliaEvent', { title, item});
        },
        isAllowedToDisplayActionBanner(index, actionBanners , amountOfItems, type = 0) {
            if (((index + 1) % amountOfItems) === 0 && type === 0) {
                return true;
            }

            return actionBanners[(index + 1) - amountOfItems];
        },
        formatItems(items, actionBanners, amountOfItems) {
            items.forEach((item, index) => {
                let shouldPushIntoItem = this.isAllowedToDisplayActionBanner(index, actionBanners, amountOfItems);

                if (shouldPushIntoItem) {
                    items.splice(index, 0, this.isAllowedToDisplayActionBanner(index, actionBanners, amountOfItems), 1)
                }
            });

            return items;
        },
    }
};
</script>
